<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PayItemTypeForm from "../../../components/payroll/payitemtype/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PayItemTypeForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuppayitmetype.createnewpayitemtype'),
      pageTitleValue: "",
      formData: {
        payitemtypecode: null,
        payitemtypedesc: null,
        payitemcatid: null,
        // startdate: null,
        // enddate: null,
        afnetpay: false,
        afgrosspay: false,
        isvendor: false,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      console.log(vm.formData);
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      // change boolean to int
      if (this.formData.afnetpay == true) {
        this.formData.afnetpay = 1;
      } else {
        this.formData.afnetpay = 0;
      }

      if (this.formData.afgrosspay == true) {
        this.formData.afgrosspay = 1;
      } else {
        this.formData.afgrosspay = 0;
      }

      if (this.formData.isvendor == true) {
        this.formData.isvendor = 1;
      } else {
        this.formData.isvendor = 0;
      }

      this.$store.dispatch('post', {url: "/payitemtype/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemtypelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "payitemtypelist" });
    },
  },
};
</script>